import { LocalizationContext } from "../localization/index.js";
import React from "react";
export const ProductContext = React.createContext({});
ProductContext.displayName = "ProductContext";
export const ProductProvider = ({ children, edition, externalProductUrl, product, storeId }) => {
    const { mode } = React.useContext(LocalizationContext);
    if (mode === "store" && !storeId) {
        throw new Error(`Expected a store id for product ${product.title}, since localization mode is set to store`);
    }
    if (mode === "catalogue" && !externalProductUrl) {
        throw new Error(`Expected an externalProductUrl for product ${product.title}, since localization mode is set to catalogue`);
    }
    return (React.createElement(ProductContext.Provider, { value: {
            ...product,
            edition,
            externalProductUrl: externalProductUrl ?? "",
            storeId: storeId ?? "",
        } }, children));
};
//# sourceMappingURL=provider.js.map